import { Card, CardBody, CardHeader } from "reactstrap";
import { ProgramacionFilter } from "../components/list.filter";
import moment from "moment";
import { useFormik } from "formik";
import { ProgramacionList } from "../components/programacion.list";
import { useProgramacion } from "../hooks/useProgramacion";
import { useEffect, useState } from "react";
import { AddProgramacion } from "../components/add.programacion";
import { EditarProgramacion } from "../components/edit.programacion";
import { AsignarProgramacion } from "../components/asignar.programacion";
import { programacionFilterValidationSchema } from "../constants/validations";
import { useCallback } from "react";
import { saveAs } from "file-saver";
import { SkeletonTable } from "../../../components/Skeleton.Table";
import { useSearchParams } from "react-router-dom";

const initialValues = {
  fecha: moment().format("YYYY-MM-DD"),
  id_cultivo: 0,
};

const validationSchema = programacionFilterValidationSchema;

export default function ProgramacionIndex() {
  // hooks
  const [searchParams] = useSearchParams();
  const paramsFecha = searchParams.get("fecha");
  const { getProgramacion, downloadProgramacion } = useProgramacion();

  // Data
  const [programacion, setProgramacion] = useState([]);

  // Loading status
  const [isLoading, setIsLoading] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  // Elements
  const [editingElement, setEditingElement] = useState(null);
  const [asignElement, setAsignElement] = useState(null);

  const onSave = () => {
    setIsAdding(false);
    setEditingElement(null);
    getProgramacionData();
  };

  const onCancel = () => {
    setIsAdding(false);
    setEditingElement(null);
  };

  const onEditnig = (id) => {
    setEditingElement(id);
  };

  const handleAssigned = (programacion) => {
    setAsignElement(programacion);
  };

  const onReloadAssigned = () => {
    setAsignElement(null);
    getProgramacionData();
  };

  const { values, handleChange, setFieldValue, validateForm } = useFormik({
    initialValues,
    onSubmit: () => {},
    validationSchema,
  });

  const downloadExcel = async () => {
    const validation = await validateForm();
    const isValid = Object.keys(validation).length === 0;
    if (isValid) {
      setIsDownloadLoading(true);
      try {
        const response = await downloadProgramacion(
          values.id_cultivo,
          values.fecha
        );
        saveAs(
          response,
          `PROGRAMACIÓN DE EMPAQUE ${moment(values.fecha).format(
            "YYYY-MM-DD"
          )}.xlsx`
        );
      } catch (error) {
        console.error(error);
      } finally {
        setIsDownloadLoading(false);
      }
    }
  };

  const getProgramacionData = useCallback(async () => {
    const validation = await validateForm();
    const isValid = Object.keys(validation).length === 0;

    if (isValid) {
      setIsLoading(true);
      const response = await getProgramacion(values.fecha, values.id_cultivo);
      setProgramacion(response);
      setIsLoading(false);
    }
  }, [values, getProgramacion, validateForm]);

  useEffect(() => {
    getProgramacionData();
  }, [getProgramacionData]);

  useEffect(() => {
    if (paramsFecha) {
      setFieldValue("fecha", paramsFecha);
    }
  }, [paramsFecha, setFieldValue]);

  return (
    <Card className="my-2">
      <CardHeader style={{ textAlign: "center", fontWeight: "bold" }}>
        Programación de empaque
      </CardHeader>
      <CardBody>
        {!isAdding && !editingElement && (
          <>
            <ProgramacionFilter
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              onAddClick={() => setIsAdding(true)}
              onDownloadClick={downloadExcel}
              isDownloadLoading={isDownloadLoading}
            />
            <br />
            {isLoading ? (
              <SkeletonTable />
            ) : (
              <ProgramacionList
                data={programacion}
                onDelete={onSave}
                onEditingClick={onEditnig}
                fecha={values.fecha}
                onAssignedClik={handleAssigned}
              />
            )}
          </>
        )}
        {isAdding && (
          <AddProgramacion
            onSave={onSave}
            onCanel={onCancel}
            fecha={values.fecha}
          />
        )}
        {editingElement && (
          <EditarProgramacion
            onSave={onSave}
            id_programacion={editingElement}
            onCancel={onCancel}
          />
        )}
        {asignElement && (
          <AsignarProgramacion
            isVisible={asignElement !== null}
            programacion={asignElement}
            fecha={values.fecha}
            onClose={() => setAsignElement(null)}
            reload={onReloadAssigned}
          />
        )}
      </CardBody>
    </Card>
  );
}
